const proBaseURL = 'https://work.api.sczsie.cn/'; //生产环境

export const BASE_URL = process.env.NODE_ENV === 'development' ? '' : proBaseURL;
// export const BASE_URL = proBaseURL;
export const TIMEOUT = 60000;